import React, {useEffect, useMemo, useState} from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, {Dayjs} from "dayjs";
import {DemoItem} from "@mui/x-date-pickers/internals/demo";

type DateInputProps = {
    id: string,
    label: string,
    value: Dayjs | null,
    handleChange: (field: string, value: Dayjs) => void
    disablePast?: boolean
    required?: boolean
    invalid?: boolean
}

export default function DateInput(props: DateInputProps) {
    const [value, setValue] = useState<Dayjs | null>(props.value);
    
    const today = useMemo(() => {
        const date = dayjs().startOf('day')
        return date
    }, [])

    useEffect(() => {
        if (value !== props.value)
        setValue(props.value)
    }, [props.value]);

    const handleChange = (newValue: Dayjs) => {
        props.handleChange(props.id, newValue)
        setValue(newValue)
    }
    
    return (
        <div className={`bLoyal-center ${props.invalid === true ? 'bLoyal-invalid-label' : ''}`} style={{width: '100%', maxWidth: '290px'}}>
            <DemoItem label={props.label} >
                {/*// @ts-ignore*/}
                <DatePicker value={value} onChange={handleChange} minDate={props.disablePast ? today : undefined} slotProps={{ textField: { required: props.required === true, error: props.invalid === true }}} />
            </DemoItem>
        </div>
    )
}